var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"mr-2",attrs:{"pressed":_vm.groupRuns,"size":"sm"},on:{"click":function($event){_vm.groupRuns = !_vm.groupRuns}}},[_c('i',{staticClass:"lely-icon-copy"}),_vm._v(" Group by runs ")])}
var staticRenderFns = []

export { render, staticRenderFns }